import React from 'react';
import {Alert, Grid} from '@mui/material';

interface AlertErrorProps {
  error: string | null;
  withinGrid: boolean;
}

export const AlertError: React.FC<AlertErrorProps> = ({ error, withinGrid }) => {
  if (!error) {
    return null;
  }
  if (withinGrid) {
    return (
      <Grid item xs={12} sm={12}>
        <Alert severity="error">{error}</Alert>
      </Grid>
    )
  }
  return <Alert severity="error">{error}</Alert>;
}
